import * as React from 'react'

const ScaleImage = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg
    className="scale active"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="100%"
    viewBox="0 0 436 249"
    xmlSpace="preserve"
    enableBackground="new 0 0 436 249"
    {...props}
  >
    <g id="Layer_1_00000127725045917262924540000001810938850347044025_">
      <path
        id="Layer_5_1_"
        className="st0"
        d="M298.1,233.7h-4.8c0-41.8-33.9-74.1-75.7-74.1s-75.7,32.3-75.7,74.1h-4.8
		c0-44.4,36.2-78.9,80.5-78.9S298.1,189.3,298.1,233.7L298.1,233.7z"
      />
      <g id="Layer_4_1_">
        <path
          className="st1"
          d="M163.8,178.7L64.6,79.6c-21.2,21.2-36.6,44.5-47.9,72.5l129.2,52.2C150.1,194.5,156.2,185.8,163.8,178.7z"
        />
        <path
          className="st2"
          d="M145.9,204.3L16.7,152.1C5.5,180,0.8,203.6,0.8,233.7h138.7C139.8,223.3,142.1,213.3,145.9,204.3z"
        />
        <path
          className="st3"
          d="M289,203.5l129.2-55c-11.7-27.6-25.2-47.7-46.4-68.9l-99.6,99.6C279,186.1,284.8,194.3,289,203.5z"
        />
        <path
          className="st4"
          d="M295.7,233.7h139.8c0-30.1-5.6-57.5-17.4-85.2l-129.2,55C293.1,212.6,295.4,222.9,295.7,233.7L295.7,233.7z"
        />
        <path
          className="st5"
          d="M271.9,179.2l99.8-99.8c-21.2-21.2-44.5-36.6-72.5-47.9l-53,131.1C255.8,166.5,264.7,172.1,271.9,179.2
			L271.9,179.2z"
        />
        <path
          className="st6"
          d="M246,162.5l52.9-130.7c-27.6-11.2-50.9-15.7-80.7-15.7v141.1C228,157.4,237.4,159.1,246,162.5L246,162.5z"
        />
        <path
          className="st7"
          d="M217.6,157.2h0.6V16.1c-29.7,0-56.7,5.5-84,17l55,129.4C198,159.1,207.5,157.2,217.6,157.2L217.6,157.2z"
        />
        <path
          className="st8"
          d="M188.7,162.7l-55-129.5C106.1,44.9,86,58.4,64.8,79.6l99,99C171,171.8,179.3,166.4,188.7,162.7z"
        />
      </g>
      <g id="Layer_1_2_">
        <path id="Ebene_1_1_" className="st0" d="M245.6,162.3l53.8-131.5l1.5,0.6l-53.8,131.5L245.6,162.3z" />
        <path
          className="st0"
          d="M146.2,203.5L17.8,151.6c11.1-27.3,25.9-50,46.8-70.9l98.7,98.5c0.3-0.3,0.8-0.6,1.1-1.1L65.2,78.9l-0.6-0.6
			L64,78.9c-21.4,21.5-36.6,44.7-48.1,72.8l-0.3,0.8l130,52.4C145.8,204.5,146.1,204,146.2,203.5z"
        />
        <path
          className="st0"
          d="M1.6,232.9c0.2-29.1,4.7-52.4,15.6-79.7l128.4,51.7c0.2-0.5,0.5-1,0.6-1.4l-130-52.6l-0.3,0.8
			C4.7,180,0,203.6,0,233.7h1.6C1.6,233.2,1.6,233.4,1.6,232.9L1.6,232.9z M164.7,177.8L65.9,79.1c20.6-20.4,40.2-33.6,67-45
			L188,162.8c0.5-0.2,1.1-0.5,1.6-0.6L134.4,32.8L134,32l-0.8,0.3c-27.8,11.7-47.7,25.2-68.9,46.1l-0.6,0.6l100,99.8L164.7,177.8z"
        />
        <path
          className="st0"
          d="M217.4,157.2h1.6V15.3h-0.8c-30.1,0-56.9,5.3-84.4,17l0.6,1.6c27.2-11.6,53.5-16.9,82.9-17V157.2z"
        />
        <path
          className="st0"
          d="M218.2,15.3h-0.8v141.9h1.6V16.7c29.2,0.2,52.4,4.7,79.5,15.7l0.6-1.4C271.6,20,248.1,15.3,218.2,15.3z
			 M271.4,178.7l1.1,1.1L373,79.6l-0.6-0.6c-21.5-21.4-44.7-36.6-72.8-48.1l-0.6,1.4c27.8,11.1,50.5,26,71.7,47.2L271.4,178.7
			L271.4,178.7z"
        />
        <path
          className="st0"
          d="M272.6,179.9l99.2-99.2c20.6,20.7,33.7,40.3,45.5,67.3l-128.6,54.6c0.3,0.5,0.5,1.1,0.6,1.6l130-55.1
			l-0.3-0.8c-11.9-28-25.4-48.1-46.6-69.3l-0.6-0.6L271.4,178.7L272.6,179.9L272.6,179.9z"
        />
        <path
          className="st0"
          d="M418.8,148.2l-0.3-0.8l-130,55.3c0.2,0.5,0.5,1,0.6,1.6l128.4-54.5c11.4,26.8,16.9,54.2,17,83.2h0v0.8h1.4
			C436.2,203.8,430.5,175.8,418.8,148.2z"
        />
      </g>
    </g>
    <g id="Layer_2_00000036970702734495545710000000452617094508675747_"></g>
    <g id="Layer_2_00000025406886136499873090000016503846361822610607_"></g>
  </svg>
)
export default ScaleImage
